<ion-grid class="setup-container">
  <ion-row>
    <ion-col>
      <ion-title>
        <h1>Oppsett</h1>
      </ion-title>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="progress-bar">
      <ion-progress-bar [value]="getProgress()"></ion-progress-bar>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="currentStep === 0">
    <ion-col class="text-block mx-4">
      <h2>Bil funnet!</h2>
      <p>
        Sammenkoblingen er vellykket, din bil
        <strong>{{ vehicle?.vendor }} {{ vehicle?.information?.model }}</strong>
        er nå lagt til.
      </p>
      <p class="mb-6">
        Neste steg er å legge til en adresse og ladeplan for din smartlading.
      </p>
      <img src="/assets/img/shared/success.svg" />
    </ion-col>
  </ion-row>
  <ion-row *ngIf="currentStep === 1">
    <app-charging-location
      [isSetup]="true"
      (emitProgressSetup)="continue()"
      (emitCancelSetup)="back()"
      (emitLocationName)="setLocationName($event)"
    ></app-charging-location>
  </ion-row>
  <ion-row *ngIf="currentStep === 2">
    <ion-col class="text-block mx-4">
      <h2>Sett din daglige frist</h2>
      <p>
        Snart i mål! Vi trenger bare å vite når bilen din skal være ferdig ladet
        hver dag.
      </p>
      <app-deadline-picker
        [deadline]="selectedTime"
        [duringSetup]="true"
        (emitSelectedTime)="setSelectedTime($event)"
        id="airDeadline"
      ></app-deadline-picker>
      <p>Du kan alltids endre dette senere.</p>
      <p *ngIf="smartChargePolicyErrorMessage">
        {{ smartChargePolicyErrorMessage }}
      </p>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="currentStep === totalSteps">
    <ion-col class="text-block mx-4">
      <h2>Suksess!</h2>
      <p class="mb-8">
        Smartlading er klart til å brukes. Ditt kjøretøy vil bli ferdig oppladet
        til {{ selectedTime }} hver dag når den er tilkoblet {{ locationName }}.
      </p>
      <p>
        Det kan hende det tar litt tid før all informasjon om bilen dukker opp
        første gang. Kontakt oss hvis du opplever vedvarende problemer.
      </p>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="currentStep !== 1">
    <ion-col class="button-container">
      <ion-button *ngIf="currentStep !== 0" (click)="back()"
        >Tilbake</ion-button
      >
      <ion-button
        *ngIf="currentStep !== totalSteps"
        (click)="continue()"
        class="dark"
        >Fortsett</ion-button
      >
      <ion-button
        *ngIf="currentStep === totalSteps"
        (click)="finish()"
        class="dark"
        >Ferdig</ion-button
      >
    </ion-col>
  </ion-row>
</ion-grid>
